import { AvatarInvertedPortfolio } from './AvatarInvertedPortfolio';
import WrapperBackgroundBanner from './WrapperBackgroundBanner';
import WrapperContentApp from './WrapperContentApp';

export const HeaderProducts = ({ fileAs, goToProductDetail, details }) => {
  return (
    <>
      <WrapperBackgroundBanner>
        <WrapperContentApp fileAs={fileAs}>
          <AvatarInvertedPortfolio
            porfolioDetailHeader={fileAs}
            goToProductDetail={goToProductDetail}
            details={details}
          />
        </WrapperContentApp>
      </WrapperBackgroundBanner>
    </>
  );
};
